import req from '@/service/api';
import Store from '@/store/index';
const key = '/leaf';
const leaf = {
    search(params) {
        return req('GET', key + '/search/' + Store.state.common.lang, params);
    },
    getCtxesByMenuId4All(id) {
        return req('GET', key + '/getCtxesByMenuId/' + id + '/' + Store.state.common.lang);
    },
    createContent(params) {
        return Store.state.auth.authList.isEditer ? req('POST', key + '/create', params) : { data: false };
    },
    setContent(params) {
        return Store.state.auth.authList.isEditer ? req('PUT', key + '/setContent' + '/' + Store.state.common.lang, params) : { data: false };
    },
    swap(params) {
        return Store.state.auth.authList.isEditer ? req('PUT', key + '/swap', params) : { data: false };
    },
    deleteContent(params) {
        return Store.state.auth.authList.isEditer ? req('DEL', key + '/remove', { data: params }) : { data: false };
    }
};
export default leaf;
